const tabLinks = document.querySelectorAll('.result__table a');
tabLinks.forEach((item) => {
  if (item.href.includes('#')) {
    const link = new URL(item.href).hash;
    item.addEventListener('click', () => {
      if (document.querySelector(`.link-box__content [href='${link}']`)) {
        document.querySelector(`.link-box__content [href='${link}']`).click();
      }
    });
  }
});
